import { render, staticRenderFns } from "./quickMitsumori.vue?vue&type=template&id=51d399d4&"
import script from "./quickMitsumori.vue?vue&type=script&lang=ts&"
export * from "./quickMitsumori.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports